import { combineReducers } from 'redux'
import auth from './user'
import newGif from './gif'
import category from './category'
import modal from './modal'
import pagination from './pagination'
import toast from './toast'

const rootReducer = combineReducers({
    auth: auth,
    Gif: newGif,
    categories: category,
    modal: modal,
    pagination: pagination,
    toast: toast
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.ts